import { fetched } from '../actions/actionTypes';
export const fetchedInitialState = {
    folders: {},
    vaultAlbums: {},
};
export default function (state = fetchedInitialState, action) {
    switch (action.type) {
        case fetched.FETCHED_FOLDER:
            const fetchedFolderPayload = action.payload;
            return { ...state, folders: { ...state.folders, [fetchedFolderPayload]: true } };
        case fetched.FETCHED_VAULT_ALBUM:
            const fetchedVaultAlbumPayload = action.payload;
            return { ...state, vaultAlbums: { ...state.vaultAlbums, [fetchedVaultAlbumPayload]: true } };
        case fetched.RESET_FETCHED:
            return fetchedInitialState;
        default:
            return state;
    }
}
